import React from 'react';
import { ScreenWrapper } from './ScreenWrapper';
import { NavBar } from '../NavBar/NavBar';
import { Grid2 } from '@mui/material';
import { TMaterialStyles } from '../../theme';

export const MainScreenWrapper: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <ScreenWrapper>
      <Grid2 sx={materialStyles.wrapper}>{children}</Grid2>
      <NavBar />
    </ScreenWrapper>
  );
};

const materialStyles: TMaterialStyles = {
  wrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
};
